
    import { createIcons, AlertCircle, ArrowLeft, ArrowRight, Box, Calculator, Camera, Check, CheckCircle, Clock, Copy, Eye, FileText, Info, Loader2, Lock, MailCheck, MapPin, MessageCircle, Package, Plane, Plus, PlusCircle, Shield, ShieldCheck, Ship, Trash2, User, X } from 'lucide';

    // public/js/main.js

/**
 * Client Entry Point
 * Initializes all client-side components using a Double RequestAnimationFrame 
 * pattern to prevent layout thrashing during component boot.
 */
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        // Safe to initialize UI components here
        document.body.classList.add('app-initialized');
    });
});


    document.addEventListener('DOMContentLoaded', () => {
      if (typeof createIcons === 'function') {
        createIcons({
          icons: { AlertCircle, ArrowLeft, ArrowRight, Box, Calculator, Camera, Check, CheckCircle, Clock, Copy, Eye, FileText, Info, Loader2, Lock, MailCheck, MapPin, MessageCircle, Package, Plane, Plus, PlusCircle, Shield, ShieldCheck, Ship, Trash2, User, X },
          attrs: { 'class': 'lucide-icon', 'aria-hidden': 'true' }
        });
      }
    });
  